import React from "react";
import { TrackNowTable } from "../ui";
import { GoogleIconButton } from "../ui/GoogleIconButton";
import { useCommonDetailsContext } from "../../context/Common/common";
import { tokens } from "../../theme/tokens";

export default function UploadedFilesTable(props: {
  files: Object[];
  handleFileAttachmentDelete: (attachmentId: any, attachmentPath: any) => void;
}) {
  const { publishedBranding, clientScopedBranding, validateParentData } = useCommonDetailsContext();
  const activeBranding = validateParentData?.isSingleParent
    ? publishedBranding
    : (clientScopedBranding || publishedBranding);
  const primaryColor =
    activeBranding?.primaryColor || tokens.colors.connectedPurple;
  
  const columns = [
    {
      id: 'name',
      label: 'Uploaded Files',
      minWidth: 200,
      clickable: true,
    },
    {
      id: 'actions',
      label: 'Actions',
      align: 'center' as const,
      minWidth: 100,
      renderCell: (value: any, row: any) => (
        <div style={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
          <GoogleIconButton
            iconName="delete"
            iconColor={primaryColor}
            onClick={() => {
              props.handleFileAttachmentDelete(
                row.attachmentId,
                row.attachmentPath
              );
            }}
            sx={{
              '&:hover': {
                backgroundColor: `${primaryColor}1A`,
              },
              '& .MuiTouchRipple-root .MuiTouchRipple-child': {
                backgroundColor: primaryColor,
              },
            }}
          />
        </div>
      ),
    },
  ];

  return (
    <TrackNowTable
      columns={columns}
      rows={props.files}
      compact
    />
  );
}
